import {
    BaseLayer
} from "esdm-map";
import { IBaseLayer } from "esdm-map/dist/baselayers/interfaces/IBaseLayer";
import TileLayer from "ol/layer/Tile";
import WMTS from "ol/source/WMTS";
import WMTSTileGrid from "ol/tilegrid/WMTS";

export class Merseyside_BaseLayers{
               
    public GetMerseysideOS(): IBaseLayer {
        let lyr = new TileLayer({
            visible: true,
            source: new WMTS({                
                url: "/api/ogcservice/MerseysideOS",
                layer: "Road 27700",
                matrixSet: "EPSG:27700",
                format: "image/png",
                projection: "EPSG:27700",
                tileGrid: new WMTSTileGrid({
                    origin: [-238375.0, 1376256.0],
                    resolutions: [896, 448, 224, 112, 56, 28, 14, 7, 3.5, 1.75, 0.875, 0.4375, 0.21875, 0.109375],
                    matrixIds: ["EPSG:27700:0", "EPSG:27700:1", "EPSG:27700:2", "EPSG:27700:3", "EPSG:27700:4", "EPSG:27700:5", "EPSG:27700:6", "EPSG:27700:7", "EPSG:27700:8", "EPSG:27700:9", "EPSG:27700:10", "EPSG:27700:11", "EPSG:27700:12", "EPSG:27700:13"]
                }),
                style: "default",
                wrapX: false,
                attributions: "© Crown copyright and database rights 2021 OS 100018816. You are granted a non-exclusive, royalty free, revocable licence solely to view the licensed data for non-commercial purposes for the period during which Sheffield City Council makes it available. You are not permitted to copy, sub-license, distribute, sell or otherwise make available the licensed data to third parties in any form. Third party rights to enforce the terms of this licence shall be reserved to OS."
            })
        });
        
        return new BaseLayer("MerseysideCustom", "Ordnance Survey", lyr);
    }
}